/**
 * @generated SignedSource<<ecbae6c0d17264530467a80ba82c92d8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type suggestedRequestForms_HelpLayoutListOfHelpCenterSuggestedRequestFormsAtomicElement$data = {
  readonly suggestedRequestTypes: ReadonlyArray<{
    readonly iconUrl: string | null;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"recentFormsListItem_on_RequestForm">;
  }> | null;
  readonly visualConfig: {
    readonly titleColor: string | null;
  } | null;
  readonly " $fragmentType": "suggestedRequestForms_HelpLayoutListOfHelpCenterSuggestedRequestFormsAtomicElement";
};
export type suggestedRequestForms_HelpLayoutListOfHelpCenterSuggestedRequestFormsAtomicElement$key = {
  readonly " $data"?: suggestedRequestForms_HelpLayoutListOfHelpCenterSuggestedRequestFormsAtomicElement$data;
  readonly " $fragmentSpreads": FragmentRefs<"suggestedRequestForms_HelpLayoutListOfHelpCenterSuggestedRequestFormsAtomicElement">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "suggestedRequestForms_HelpLayoutListOfHelpCenterSuggestedRequestFormsAtomicElement",
  "selections": [
    {
      "concreteType": "HelpLayoutRequestForm",
      "kind": "LinkedField",
      "name": "suggestedRequestTypes",
      "plural": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "recentFormsListItem_on_RequestForm"
        },
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "iconUrl"
        }
      ]
    },
    {
      "concreteType": "HelpLayoutVisualConfig",
      "kind": "LinkedField",
      "name": "visualConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "titleColor"
        }
      ]
    }
  ],
  "type": "HelpLayoutSuggestedRequestFormsListElement"
};

(node as any).hash = "9adc806ca3099844b30ed5f33c8bc772";

export default node;
